const Social = ({
  strings,
}) => {
  /*------------------------------
  Render
  ------------------------------*/
  return (
    <>
      {strings?.facebook_url !== ''
        ? (
          <a key="fb" href={strings.facebook_url} target="_blank">
            <svg>
              <use xlinkHref="#ico-fb" />
            </svg>
          </a>
        )
        : null}
      {strings?.instagram_url !== ''
        ? (
          <a key="ig" href={strings.instagram_url} target="_blank">
            <svg>
              <use xlinkHref="#ico-ig" />
            </svg>
          </a>
        )
        : null}
      {strings?.linkedin_url !== ''
        ? (
          <a key="li" href={strings.linkedin_url} target="_blank">
            <svg>
              <use xlinkHref="#ico-li" />
            </svg>
          </a>
        )
        : null}
      {strings?.youtube_url !== ''
        ? (
          <a key="yt" href={strings.youtube_url} target="_blank">
            <svg>
              <use xlinkHref="#ico-yt" />
            </svg>
          </a>
        )
        : null}
    </>
  )
}
Social.defaultProps = {
  strings: null,
}

export default Social
